import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SearchStatus } from '../constants';
import { resetError, resetSaveSendTripEmailStatus } from '../store/slices/trip';

// Hook
const useResetSaveTripStatus = (saveSendTripEmailStatus, error) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (saveSendTripEmailStatus === SearchStatus.DONE) {
      setTimeout(() => {
        dispatch(resetError());
        dispatch(resetSaveSendTripEmailStatus());
      }, 5000);
    }
  }, [dispatch, saveSendTripEmailStatus, error]);
};

export default useResetSaveTripStatus;
